import { createAsyncThunk } from '@reduxjs/toolkit';
import ErrorNotifier, { Severity } from 'app/scripts/services/error-notifier';
import { fetchAllLiveBlogs } from '../../api';
import { LiveEvent, LiveBlogSorting } from '../types';
import { parseLiveEvent } from '../parsers';

interface Payload {
  count: number;
  offset: number;
  sortBy: LiveBlogSorting;
}

interface Returned {
  liveEvents: LiveEvent[];
  totalEvents: number;
}

const defaultPayload: Payload = {
  count: 1100,
  offset: 0,
  sortBy: LiveBlogSorting.EndingTime
};

export const fetchLiveBlogEvents = createAsyncThunk<Returned, Partial<Payload> | void>(
  'LIVE_BLOG/FETCH_LIVE_BLOG_EVENTS',
  async ({
    count = 1100,
    offset = 0,
    sortBy = LiveBlogSorting.EndingTime
  }: Payload = defaultPayload) => {
    try {
      const { events, total_events: totalEvents } = await fetchAllLiveBlogs({
        count,
        offset,
        sortBy: 'newest'
      });
      const liveEvents = (events || []).map(parseLiveEvent);
      return { liveEvents, totalEvents };
    } catch (err) {
      console.error(err);
      ErrorNotifier.notifyError(`Failed to fetch all live blog information list`, {
        level: Severity.Critical
      });
      throw err;
    }
  }
);
